const Types = {
  GET_REGISTERS_REQUEST: '@registerFrom/GET_REGISTERS_REQUEST',
  GET_REGISTERS_SUCCESS: '@registerFrom/GET_REGISTERS_SUCCESS',
};

export default Types;
